import { ActiveDirectoryRole } from './ActiveDirectoryRole';

export type RoleAllowedList = Set<ActiveDirectoryRole>;

const CanViewAdministrativeUnits: RoleAllowedList = new Set([
  ActiveDirectoryRole.ApplicationAdministrator,
  ActiveDirectoryRole.AuthenticationAdministrator,
  ActiveDirectoryRole.AzureDevOpsAdministrator,
  ActiveDirectoryRole.AzureInformationProtectionAdministrator,
  ActiveDirectoryRole.B2CIEFKeysetAdministrator,
  ActiveDirectoryRole.B2CIEFPolicyAdministrator,
  ActiveDirectoryRole.B2CUserflowAdministrator,
  ActiveDirectoryRole.B2CUserFlowAttributeAdministrator,
  ActiveDirectoryRole.BillingAdministrator,
  ActiveDirectoryRole.CloudApplicationAdministrator,
  ActiveDirectoryRole.CloudDeviceAdministrator,
  ActiveDirectoryRole.CompanyAdministrator,
  ActiveDirectoryRole.ComplianceAdministrator,
  ActiveDirectoryRole.ComplianceDataAdministrator,
  ActiveDirectoryRole.ConditionalAccessAdministrator,
  ActiveDirectoryRole.CRMServiceAdministrator,
  ActiveDirectoryRole.DesktopAnalyticsAdministrator,
  ActiveDirectoryRole.DeviceAdministrators,
  ActiveDirectoryRole.ExchangeServiceAdministrator,
  ActiveDirectoryRole.ExternalIdentityProviderAdministrator,
  ActiveDirectoryRole.GroupAdministrator,
  ActiveDirectoryRole.HelpdeskAdministrator,
  ActiveDirectoryRole.IntuneServiceAdministrator,
  ActiveDirectoryRole.KaizalaAdministrator,
  ActiveDirectoryRole.LicenseAdministrator,
  ActiveDirectoryRole.LyncServiceAdministrator,
  ActiveDirectoryRole.OfficeAppsAdministrator,
  ActiveDirectoryRole.PasswordAdministrator,
  ActiveDirectoryRole.PowerBIServiceAdministrator,
  ActiveDirectoryRole.PowerPlatformAdministrator,
  ActiveDirectoryRole.PrivilegedAuthenticationAdministrator,
  ActiveDirectoryRole.PrivilegedRoleAdministrator,
  ActiveDirectoryRole.SearchAdministrator,
  ActiveDirectoryRole.SecurityAdministrator,
  ActiveDirectoryRole.ServiceSupportAdministrator,
  ActiveDirectoryRole.SharePointServiceAdministrator,
  ActiveDirectoryRole.TeamsCommunicationsAdministrator,
  ActiveDirectoryRole.TeamsServiceAdministrator,
  ActiveDirectoryRole.UserAccountAdministrator,
]);

export const RoleAllowedLists = {
  CanViewAdministrativeUnits,
};
